import { useTranslation } from "react-i18next";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  BankIcon,
  Building06Icon,
  CreditCardIcon,
  Invoice01Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import PaymentPaymentTypes from "enums/PaymentPaymentTypes";
import { Inline } from "components/layout/reusableLayouts";
import { paymentMethodLabelKey } from "utils/payments/paymentMethod";

interface RenderPaymentMethodProps {
  method: PaymentPaymentTypes | string | null | undefined;
}

const ICON_SIZE = 16;

const methodIcons: Record<PaymentPaymentTypes, JSX.Element> = {
  [PaymentPaymentTypes.ACH]: (
    <HugeiconsIcon icon={Building06Icon} size={ICON_SIZE} />
  ),
  [PaymentPaymentTypes.WIRE]: (
    <HugeiconsIcon icon={BankIcon} size={ICON_SIZE} />
  ),
  [PaymentPaymentTypes.CHECK]: (
    <HugeiconsIcon icon={Invoice01Icon} size={ICON_SIZE} />
  ),
  [PaymentPaymentTypes.CREDIT_CARD]: (
    <HugeiconsIcon icon={CreditCardIcon} size={ICON_SIZE} />
  ),
};

/** Method name with its glyph, for every surface that names one. */
export const RenderPaymentMethod: React.FC<RenderPaymentMethodProps> = ({
  method,
}) => {
  const { t } = useTranslation();

  const labelKey = paymentMethodLabelKey(method);
  if (!labelKey) return null;

  return (
    <Inline gap="var(--space-2)" wrap={false}>
      <Inline
        sx={{ color: "var(--color-text-tertiary)", flexShrink: 0 }}
        wrap={false}
      >
        {methodIcons[method as PaymentPaymentTypes]}
      </Inline>
      {t(labelKey)}
    </Inline>
  );
};

export default RenderPaymentMethod;
